function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Odhlasit sa");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Mobil-Menu-1_0_0",
  transform: "translate(-327.000000, -637.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(24.000000, 156.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Odhlasit-sa",
  transform: "translate(303.000000, 481.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,1 L8,1 C6.06700338,1 4.31700338,1.78350169 3.05025253,3.05025253 C1.78350169,4.31700338 1,6.06700338 1,8 L1,16 C1,17.9329966 1.78350169,19.6829966 3.05025253,20.9497475 C4.31700338,22.2164983 6.06700338,23 8,23 L16,23 C17.9329966,23 19.6829966,22.2164983 20.9497475,20.9497475 C22.2164983,19.6829966 23,17.9329966 23,16 L23,8 C23,6.06700338 22.2164983,4.31700338 20.9497475,3.05025253 C19.6829966,1.78350169 17.9329966,1 16,1 Z",
  id: "Rectangle",
  stroke: "#F71D1D",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0007361,5.6739809 C17.3652866,6.7975953 19,9.20789376 19,12 C19,15.8659932 15.8659932,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,9.20749895 6.63517574,6.79691366 9.00026701,5.67350433 L8.99980567,7.99977979 C7.7854695,8.91199508 7,10.3642694 7,12 C7,14.7614237 9.23857625,17 12,17 C14.7614237,17 17,14.7614237 17,12 C17,10.3647208 16.2149639,8.91279657 15.0011995,8.00053506 L15.0007361,5.6739809 Z M12,5 C12.5522847,5 13,5.44771525 13,6 L13,10 C13,10.5522847 12.5522847,11 12,11 C11.4477153,11 11,10.5522847 11,10 L11,6 C11,5.44771525 11.4477153,5 12,5 Z",
  id: "Combined-Shape",
  fill: "#F71D1D",
  fillRule: "nonzero"
})))));

var SvgLogOut = function SvgLogOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/log-out.58440e56.svg";
export { ForwardRef as ReactComponent };